import { memo, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";

const ProtectedRoute = memo(function ProtectedRoute({
  children,
  disabled = false,
}) {
  const { user, loading, status } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg font-semibold">Loading...</p>
      </div>
    );
  }

  if (disabled) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        404 not found
      </div>
    );
  }

  if (user && user?._id && status === "authenticated") {
    return children;
  }

  return <Navigate to={"/login"} />;
});

export default ProtectedRoute;
